import React, { useEffect, useState, useCallback } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import {
  DEFAULT_PREFERENCES,
  acceptAll,
  rejectAll,
  readStoredConsent,
  reapplyStoredConsent,
  updateConsent,
} from "@/consent";

export default function CookieBanner({ openSignal }) {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);
  const [managing, setManaging] = useState(false);
  const [prefs, setPrefs] = useState(DEFAULT_PREFERENCES);

  useEffect(() => {
    const stored = readStoredConsent();
    if (stored && stored.preferences) {
      reapplyStoredConsent();
      setPrefs(stored.preferences);
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (openSignal > 0) {
      const stored = readStoredConsent();
      if (stored && stored.preferences) setPrefs(stored.preferences);
      setManaging(true);
      setVisible(true);
    }
  }, [openSignal]);

  const close = useCallback(() => {
    setVisible(false);
    setManaging(false);
  }, []);

  const handleAcceptAll = () => {
    const p = acceptAll();
    setPrefs(p);
    close();
  };
  const handleRejectAll = () => {
    const p = rejectAll();
    setPrefs(p);
    close();
  };
  const handleSave = () => {
    const p = updateConsent(prefs);
    setPrefs(p);
    close();
  };

  if (!visible) return null;

  return (
    <div className="dma-cookie" role="dialog" aria-modal="false" aria-labelledby="cookie-title">
      <div className="dma-cookie__inner">
        {!managing ? (
          <>
            <div className="dma-cookie__text">
              <h3 id="cookie-title" className="dma-cookie__title">
                {t("cookies.bannerTitle")}
              </h3>
              <p>{t("cookies.bannerText")}</p>
            </div>
            <div className="dma-cookie__actions">
              <button type="button" className="dma-btn dma-btn--ghost" onClick={() => setManaging(true)}>
                {t("cookies.manage")}
              </button>
              <button type="button" className="dma-btn dma-btn--outline" onClick={handleRejectAll}>
                {t("cookies.rejectAll")}
              </button>
              <button type="button" className="dma-btn dma-btn--primary" onClick={handleAcceptAll}>
                {t("cookies.acceptAll")}
              </button>
            </div>
          </>
        ) : (
          <div className="dma-cookie__manage">
            <div className="dma-cookie__manage-head">
              <h3 className="dma-cookie__title" id="cookie-title">
                {t("cookies.prefTitle")}
              </h3>
              <p>{t("cookies.prefIntro")}</p>
            </div>
            <ul className="dma-cookie__list">
              <li className="dma-cookie__row">
                <div>
                  <strong>{t("cookies.essentialTitle")}</strong>
                  <p>{t("cookies.essentialText")}</p>
                </div>
                <span className="dma-toggle is-locked" aria-disabled="true">
                  <input type="checkbox" checked readOnly aria-label={t("cookies.essentialTitle")} />
                  <span className="dma-toggle__slider" />
                </span>
              </li>
              {[
                { k: "analytics_storage", tk: "analyticsTitle", tx: "analyticsText" },
                { k: "ad_storage", tk: "adStorageTitle", tx: "adStorageText" },
                { k: "ad_user_data", tk: "adUserDataTitle", tx: "adUserDataText" },
                { k: "ad_personalization", tk: "adPersonalizationTitle", tx: "adPersonalizationText" },
              ].map((r) => (
                <li className="dma-cookie__row" key={r.k}>
                  <div>
                    <strong>{t(`cookies.${r.tk}`)}</strong>
                    <p>{t(`cookies.${r.tx}`)}</p>
                  </div>
                  <label className="dma-toggle">
                    <input
                      type="checkbox"
                      checked={!!prefs[r.k]}
                      onChange={(e) => setPrefs((p) => ({ ...p, [r.k]: e.target.checked }))}
                      aria-label={t(`cookies.${r.tk}`)}
                    />
                    <span className="dma-toggle__slider" />
                  </label>
                </li>
              ))}
            </ul>
            <div className="dma-cookie__actions">
              <button type="button" className="dma-btn dma-btn--ghost" onClick={() => setManaging(false)}>
                {t("cookies.back")}
              </button>
              <button type="button" className="dma-btn dma-btn--outline" onClick={handleRejectAll}>
                {t("cookies.rejectAll")}
              </button>
              <button type="button" className="dma-btn dma-btn--primary" onClick={handleSave}>
                {t("cookies.savePreferences")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
